import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'bdEZMQcAsaC0fRVtrC8LSFXJl5UeVu2duj6a75w7',
  authDomain: 'iu-masterplan-2021.firebaseapp.com',
  databaseURL: 'https://iu-masterplan-2021-default-rtdb.firebaseio.com',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.database();

export default db;



// WEBPACK FOOTER //
// ./src/db.js